import { Fragment } from 'react';
import Link from 'next/link';
import NextImage from '@com/_core/NextImage';
import Icon from '@utilities/icon';
import { homePageText } from '@com/texts/homePage';
import { colors } from '@configs/Theme';
import { routeList } from '@routes/routeList';

const SOCIAL_LINKS = [
  {
    href: 'https://www.instagram.com/tapsi_doctor/',
    icon: '/images/social-icon/instagram.svg',
    alt: 'Instagram',
  },
  {
    href: 'https://www.linkedin.com/company/tapsi-doctor/',
    icon: '/images/social-icon/linkedin.svg',
    alt: 'LinkedIn',
  },
  {
    href: 'https://www.aparat.com/Tapsi_doctor',
    icon: '/images/social-icon/aparat.svg',
    alt: 'Aparat',
  },
  {
    href: 'https://t.me/Tapsidoctor1',
    icon: '/images/social-icon/telegram.svg',
    alt: 'Telegram',
  },
];

const CONTACT_INFO = {
  phone: '02141630500',
  email: 'info@tapsi.doctor',
};

export default function FooterContent() {
  const enamadUrl = `${process.env.NEXT_PUBLIC_ENAMAD_API_URL}/?id=${process.env.NEXT_PUBLIC_ENAMAD_API_ID}&Code=${process.env.NEXT_PUBLIC_ENAMAD_API_TOKEN}`;
  const enamadLogo = `${process.env.NEXT_PUBLIC_ENAMAD_API_URL}/logo.aspx?id=${process.env.NEXT_PUBLIC_ENAMAD_API_ID}&Code=${process.env.NEXT_PUBLIC_ENAMAD_API_TOKEN}`;

  return (
    <footer className="flex flex-col items-start bg-surface-inverse-primary px-4 pb-8 overflow-hidden">
      <div className="flex flex-col items-start py-6 gap-y-5 w-full">
        <NextImage
          src="/images/logo/tapsi-doctor-logo-white.svg"
          alt="Tapsi Doctor Logo"
          width={166}
          height={28}
          priority
        />

        <p className="text-sm text-white font-thin leading-6">
          {homePageText.aboutTapsiDocDesc.split('\n').map((line, index) => (
            <Fragment key={index}>
              {line}
              <br />
            </Fragment>
          ))}
        </p>

        <section
          aria-labelledby="quick-access"
          className="flex flex-col gap-y-2"
        >
          <h2 id="quick-access" className="text-base text-white font-bold">
            دسترسی سریع
          </h2>
          <ul className="list-disc footer-bullet text-sm text-white font-thin mr-5 flex flex-col gap-y-2">
            <li>
              <Link href={routeList.policyRoute}>قوانین و مقررات</Link>
            </li>
            <li>
              <Link href={routeList.blogRoute}>مجله تپسی دکتر</Link>
            </li>
            <li>
              <Link href={`tel:${CONTACT_INFO.phone}`}>پشتیبانی</Link>
            </li>
          </ul>
        </section>

        <section aria-labelledby="contact-us" className="flex flex-col gap-y-2">
          <h2 id="contact-us" className="text-base text-white font-bold">
            {homePageText.contactUs}
          </h2>

          <div className="flex flex-col gap-y-3">
            <div className="flex items-center gap-x-4">
              <Icon
                name="CallLeft"
                width={1.125}
                height={1.125}
                fill={colors.white}
              />
              <Link
                href={`tel:${CONTACT_INFO.phone}`}
                aria-label="Contact support"
              >
                <p className="text-sm text-content-onBrand cursor-pointer flex flex-wrap gap-x-2">
                  ۰۲۱-۴۱۶۳۰۵۰۰
                  <span className="font-thin text-content-disabled">
                    (پشتیبانی ۷ روز هفته از ساعت ۸ تا ۲۳)
                  </span>
                </p>
              </Link>
            </div>

            <div className="flex items-center gap-x-4">
              <Icon
                name="EnvelopeFill"
                width={1.125}
                height={1.125}
                fill={colors.white}
              />
              <Link
                href={`mailto:${CONTACT_INFO.email}`}
                aria-label="Send email"
              >
                <p className="text-sm text-content-onBrand cursor-pointer">
                  {CONTACT_INFO.email}
                </p>
              </Link>
            </div>
          </div>
        </section>
        <section
          aria-labelledby="social-media"
          className="flex flex-col gap-y-2"
        >
          <h2 id="social-media" className="text-base text-white font-bold">
            شبکه‌های اجتماعی
          </h2>
          <ul className="flex gap-x-3 list-none">
            {SOCIAL_LINKS.map(({ href, icon, alt }) => (
              <li key={alt}>
                <Link
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={alt}
                >
                  <NextImage src={icon} alt={alt} width={40} height={40} />
                </Link>
              </li>
            ))}
          </ul>
        </section>

        <section aria-labelledby="licenses" className="flex flex-col gap-y-2">
          <h2 id="licenses" className="text-base text-white font-bold my-4">
            مجوزها
          </h2>
          <div className="flex gap-x-2 items-center">
            <Link
              href={enamadUrl}
              target="_blank"
              aria-label="Enamad verification"
              className="bg-surface-primary rounded-md overflow-hidden w-20 h-20 flex items-center justify-center"
            >
              <NextImage
                src={enamadLogo}
                alt="Enamad"
                width={80}
                height={80}
                className="object-contain"
              />
            </Link>

            <Link
              href="http://tehran.irannsr.org"
              target="_blank"
              className="rounded-md overflow-hidden w-20 h-20"
            >
              <NextImage
                src="/images/social-icon/nezam-sanaye.webp"
                alt="Nezam Sanaye"
                fill
                className="object-contain"
              />
            </Link>
          </div>
        </section>

        <p className="text-content-onBrand text-center font-thin text-sm my-4 w-full">
          تمام حقوق مادی و معنوی این وبسایت متعلق به تپسی دکتر است.
        </p>
      </div>
    </footer>
    // <footer className="bg-grey-50 p-4 flex flex-col items-start">
    //   {/* About us Section */}
    //   <div className="grid grid-cols-2 border-b border-grey-100">
    //     <div className="mb-4">
    //       <p className="text-sm font-semibold mb-2">
    //         {homePageText.aboutTapsiDoc}
    //       </p>
    //       <p className="text-2xs text-grey-500">
    //         {homePageText.aboutTapsiDocDesc}
    //       </p>
    //     </div>
    //     <div className="flex flex-col items-end text-xs font-semibold pl-6 gap-y-4 mb-4">
    //       <Link href={'https://blog.tapsi.doctor/'}>
    //         <p>{homePageText.tapsiDocMag}</p>
    //       </Link>
    //       <Link href={routeList?.policyRoute}>{homePageText.policy}</Link>
    //       <Link href={`tel:02141630500`}>
    //         <p className="cursor-pointer">{homePageText.support}</p>
    //       </Link>
    //       <div className="grid grid-rows-1 grid-cols-1 w-10 h-10 overflow-hidden justify-center items-center cursor-pointer">
    //         <div
    //           className="row-start-1 col-start-1 z-2"
    //           dangerouslySetInnerHTML={{ __html: enamadCode }}
    //         />
    //       </div>
    //     </div>
    //   </div>
    //   {/* Contact us Section */}
    //   <div className="grid grid-cols-2 w-full mt-3">
    //     <div className="mb-4">
    //       <p className="text-2xs text-grey-500 mb-1">{homePageText.followUs}</p>
    //       <div className="flex">
    //         <Link
    //           href="https://www.linkedin.com/company/tapsi-doctor/"
    //           passHref
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           <LinkedintIcon
    //             height={20}
    //             width={20}
    //             fill={colors.black}
    //             innerFill={colors.white}
    //             className="cursor-pointer"
    //           />
    //         </Link>

    //         <Link
    //           href={'https://www.aparat.com/Tapsi_doctor'}
    //           passHref
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           <AparatIcon
    //             height={20}
    //             width={20}
    //             fill={colors.black}
    //             innerFill={colors.white}
    //             className="mx-2 cursor-pointer"
    //           />
    //         </Link>

    //         <Link
    //           href={'https://www.instagram.com/tapsi_doctor'}
    //           passHref
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           <InstagramIcon
    //             height={20}
    //             width={20}
    //             fill={colors.black}
    //             innerFill={colors.white}
    //             className="cursor-pointer"
    //           />
    //         </Link>
    //       </div>
    //     </div>

    //     <div className="space-y-2 text-left ml-6">
    //       <h3 className="text-2xs text-grey-500 mb-2">
    //         {homePageText.contactUs}
    //       </h3>
    //       <Link href={`tel:02141630500`}>
    //         <p className="text-2xs text-grey-800 cursor-pointer">
    //           {homePageText.contactNumber}
    //         </p>
    //       </Link>
    //     </div>
    //   </div>
    // </footer>
  );
}
